import React from 'react';

// Hooks
import { useOnboardingState } from 'Shared/utils/hooks/use-onboarding-state';

// Components
import WpIcon from 'Wpds/components/icon/WpIcon';
import { WpButton } from 'Wpds/components/button';

// Styles
import './OnboardingSlackTitle.scss';

type Props = {
  title: string;
  onNext?: Function;
  onBack?: Function;
};

const OnboardingSlackTitle = ({ title, onNext, onBack }: Props) => {
  const { isAdvancingForward, isAdvancingBack } = useOnboardingState();

  const baseClassName = 'OnboardingSlackTitle';

  return (
    <div className={baseClassName}>
      <div className={`${baseClassName}__sides`}>
        {onBack && (
          <WpButton variant="tertiary" onClick={() => onBack()} loading={isAdvancingBack}>
            <WpIcon name="arrow-left" />
          </WpButton>
        )}
      </div>
      <h5 className={`${baseClassName}__title`}>{title}</h5>
      <div className={`${baseClassName}__sides`}>
        {onNext && (
          <WpButton onClick={() => onNext()} loading={isAdvancingForward}>
            Next
          </WpButton>
        )}
      </div>
    </div>
  );
};

export default OnboardingSlackTitle;
